"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SmartSoldierTiles;
(function (SmartSoldierTiles) {
    SmartSoldierTiles["BioDroid"] = "BioDroid";
    SmartSoldierTiles["Cyborg"] = "Cyborg";
    SmartSoldierTiles["GaussCannon"] = "GaussCannon";
    SmartSoldierTiles["GolemMK3"] = "GolemMK3";
    SmartSoldierTiles["NetFighter"] = "NetFighter";
    SmartSoldierTiles["Ripper"] = "Ripper";
    SmartSoldierTiles["Transporter"] = "Transporter";
    SmartSoldierTiles["Twister"] = "Twister";
})(SmartSoldierTiles = exports.SmartSoldierTiles || (exports.SmartSoldierTiles = {}));
var SmartModuleTiles;
(function (SmartModuleTiles) {
    SmartModuleTiles["Mother"] = "Mother";
    SmartModuleTiles["Officer"] = "Officer";
    SmartModuleTiles["Scout"] = "Scout";
})(SmartModuleTiles = exports.SmartModuleTiles || (exports.SmartModuleTiles = {}));
var SmartFoundationTiles;
(function (SmartFoundationTiles) {
})(SmartFoundationTiles = exports.SmartFoundationTiles || (exports.SmartFoundationTiles = {}));
